


































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import VueWordCloud from 'vuewordcloud'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import ButtonResults from 'components/presenter/item/topic/viewer/ButtonResults.vue'

@Component({
  components: {
    VueWordCloud,
    MarkdownViewerCrdt,
    ButtonResults
  }
})
export default class ItemTopicViewerOpen extends Vue {
  response = ''
  statistics: Array<string | number>[] = [] // [[word, count], ...]

  @Prop({ default: false })
  readonly feedbackButtonShow!: boolean

  @Prop({ default: false })
  readonly feedbackButtonOn!: boolean

  @Prop()
  readonly slide!: Json

  @Prop({ default: null })
  readonly stats!: Json | null

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop()
  readonly value!: string | undefined

  @Watch('value', { immediate: true })
  update (value: string | undefined) {
    this.response = value || ''
  }

  get text () {
    return this.slide?.text?.getText()
  }

  @Watch('stats', { immediate: true, deep: true })
  createStatistics (stats: Json | undefined) {
    if (stats) {
      this.statistics = Object.keys(stats).map( key => [key, stats[key] ] )
    } else {
      this.statistics = []
    }
  }

  respond (value: string) {
    this.response = value
    this.$emit('input', value || undefined )
  }
}
